import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  titleGrande: {
    color: "#000000",
    fontSize: '1.25rem',
    fontWeight: 'bold',
    textAlign: 'start',
    marginBottom: '1rem'
  },
  title: {
    color: "#000000",
    fontSize: '16px',
    fontWeight: 'bold',
    textAlign: 'start',

    display: '-webkit-box',
    // WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    WebkitLineClamp: 3,
    minHeight: '3.6em',
    lineHeight: '1.2em',
  },

  conntentAcordion: {
    width: '100%',
    boxShadow: '0px 0px 0px #6C6C6C',
    border: '1px solid #00000029',
    borderRadius: '5px'
  },
  checkColor: {
    color: `${theme.palette.primary.main}!important`,
  },
  cardNotice: {
    cursor: 'pointer',
    height: '100%',
    transition: 'box-shadow 0.3s',
    '&:hover': {
      boxShadow: '0px 0px 4px 0px #FE5D00CC',
    },
    // boxShadow: '0px 0px 4px 0px #FE5D00CC',

  },
  banner: {
    width: '100%',
    maxWidth: '100%',
    height: '90px',
    objectFit: 'cover', // cobre toda a largura, altura se ajusta
    display: 'block',
    margin: '0 auto',
    [theme.breakpoints.down(1229)]: {
      height: '120px',
      minHeight: '120px',
      maxHeight: '120px',
    },
  },
  bannerContainer: {
    borderBottom: '15px solid #FE5D00',
  },
  cardContent: {
    padding: '16px'
  },
  noticeContent: {
    fontWeight: 400,
    fontStyle: 'Regular',
    fontSize: '14px',
    letterSpacing: '0%',
    color: '#6C6C6C',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginTop: '10px',
    minHeight: '3.6em',
    lineHeight: '1.2em',
  },

  // noticeContent: {
  //   color: "#B7B7B7",
  //   fontSize: 14,
  //   display: '-webkit-box',
  //   WebkitLineClamp: 3,
  //   WebkitBoxOrient: 'vertical',
  //   overflow: 'hidden',
  //   textOverflow: 'ellipsis',
  //   fontWeight: 'normal',
  //   "& img": {
  //     width: '90px'
  //   }
  // },

  positionText: {
    marginTop: '10px',
    color: "#FE5D00",
    fontSize: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: 'flex-start',
    gap: '2px'
  },
  moreButton: {
    borderRadius: 5,
    // paddingTop: 133.5,
    // paddingRight: 114.5,
    // paddingBottom: 133.5,
    // paddingLeft: 114.5,
    // gap: 10,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0px 0px 4px 0px #FE5D0080',

  }
}));